// extracted by mini-css-extract-plugin
export default {"container":"xs-z","brandName":"ys-z","productName":"zs-z","productNamePdpEnhancements":"As-z","breakLongProductName":"Bs-z"};